module.exports = __webpack_public_path__ + "img/gift-1.cca3816a.png";